<template>
  <div v-if="label != null" ref="element" class="PictureObject">
    <CollectorComponents
      v-for="(child, i) in src._children"
      @resize="label.resize"
      :parentOffset="label.offset"
      :src="child"
      :type="child._tipo"
      :key="i"
    />
  </div>
</template>
<script>
import LabelComponent from "@/classes/LabelComponent.js";

export default {
  name: "PictureObject",
  props: {
    src: Object,
    parentOffset: Object,
  },
  components: {
    CollectorComponents: () => import("./CollectorComponents.vue"),
  },
  data() {
    return {
      label: null,
    };
  },
  methods: {},
  mounted() {
    this.label = new LabelComponent(this);
    this.$nextTick(() => {
      const style = {
        backgroundImage: `url('data:image/${this.src.ImageFormat};base64,${this.src.Image}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        border:
          this.src.Height > 0 && this.src.Width > 0 ? `1px dashed grey` : "",
        display: "inline-block",
        height: this.src.Height === null ? "0px" : this.src.Height + "px",
        left: this.src.Left === null ? "0px" : this.src.Left + "px",
        overflow: "hidden",
        position: "absolute",
        top: this.src.Top === null ? "0px" : this.src.Top + "px",
        width: this.src.Width === null ? "0px" : this.src.Width + "px",
        boxSizing: "border-box",
      };
      this.label.getStyle(style);
      this.label.rendered = true;
    });
  },
};
</script>
